<template>
  <v-dialog
    :value="openEditFormulario"
    max-width="800px"
    persistent
  >
    <v-card
      height="100%"
      class="px-8 pt-4"
    >
      <div class="d-flex flex-row-reverse">
        <v-btn
          icon
          small
          class="mx-2 mt-2"
          @click="$emit('update:open-edit-formulario', false)"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <div class="drawer-header text-center mb-2">
        <h2 class="">
          Editar Permissões de Formulário
        </h2>
        <v-spacer></v-spacer>
      </div>

      <v-card-text>
        <v-form
          ref="formRef"
          @submit.prevent="handleUpdate"
        >
          <v-row class=" ">
            <v-col
              :md="12"
              :sm="12"
            >
              <h3 class="font-weight-medium">
                Visibilidade:
              </h3>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="cursor-pointer py-0 mt-0"
              @click="toggleCheckbox(['visivelSolicitante', 'editavelSolicitante' ])"
            >
              <v-card
                height="100"
                :color="tipoSolicitacaoFormularioData.visivelSolicitante ? '#9055fd1e' : undefined"
                elevation="1"
                outlined
              >
                <v-card-text>
                  <v-checkbox
                    v-model="tipoSolicitacaoFormularioData.visivelSolicitante"
                    class="py-1"
                    :rules="[visivelRequired]"
                    label="Visivel para Solicitante no autoatendimento"
                    @click.stop
                  ></v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="cursor-pointer py-0"
              @click="toggleCheckbox(['visivelAgente', 'editavelAgente'])"
            >
              <v-card
                height="100"
                elevation="1"
                outlined
                :color="tipoSolicitacaoFormularioData.visivelAgente ? '#9055fd1e' : undefined"
              >
                <v-card-text>
                  <v-checkbox
                    v-model="tipoSolicitacaoFormularioData.visivelAgente"
                    :rules="[visivelRequired]"
                    label="Visivel para Agente no Atendimento"
                    @click.stop
                  ></v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              :md="12"
              :sm="12"
            >
              <h3 class="font-weight-medium pb-0">
                Edição:
              </h3>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="cursor-pointer py-0"
              @click="toggleCheckbox1(['editavelSolicitante', 'visivelSolicitante'])"
            >
              <v-card
                height="100"
                elevation="1"
                outlined
                :color="tipoSolicitacaoFormularioData.editavelSolicitante ? '#9055fd1e' : undefined"
              >
                <v-card-text>
                  <v-checkbox
                    v-model="tipoSolicitacaoFormularioData.editavelSolicitante"
                    :disabled="tipoSolicitacaoFormularioData.visivelSolicitante ? false : true"
                    label="Editável para Solicitante no autoatendimento"
                    @click.stop
                  />
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="cursor-pointer py-0"
              @click="toggleCheckbox1(['editavelAgente', 'visivelAgente'])"
            >
              <v-card
                height="100"
                elevation="1"
                outlined
                :color="tipoSolicitacaoFormularioData.editavelAgente === true ? '#9055fd1e' : undefined"
              >
                <v-card-text>
                  <v-checkbox
                    v-model="tipoSolicitacaoFormularioData.editavelAgente"
                    :disabled="tipoSolicitacaoFormularioData.visivelAgente ? false : true"
                    label="Editável para Agente no Atendimento"
                    @click.stop
                  ></v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              :md="12"
              :sm="12"
            >
              <h3 class="font-weight-medium pb-0">
                Impressão:
              </h3>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="cursor-pointer py-0"
              @click="toggleCheckbox1(['editavelSolicitante', 'visivelSolicitante'])"
            >
              <v-card
                height="100"
                elevation="1"
                outlined
                :color="tipoSolicitacaoFormularioData.visivelSolicitanteImpressao ? '#9055fd1e' : undefined"
              >
                <v-card-text>
                  <v-checkbox
                    v-model="tipoSolicitacaoFormularioData.visivelSolicitanteImpressao"
                    :disabled="tipoSolicitacaoFormularioData.visivelSolicitante ? false : true"
                    label="Impressão para Solicitante no autoatendimento"
                    @click.stop
                  />
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="cursor-pointer py-0"
              @click="toggleCheckbox1(['editavelAgente', 'visivelAgente'])"
            >
              <v-card
                height="100"
                elevation="1"
                outlined
                :color="tipoSolicitacaoFormularioData.visivelAgenteImpressao === true ? '#9055fd1e' : undefined"
              >
                <v-card-text>
                  <v-checkbox
                    v-model="tipoSolicitacaoFormularioData.visivelAgenteImpressao"
                    :disabled="tipoSolicitacaoFormularioData.visivelAgente ? false : true"
                    label="Impressão para Agente no Atendimento"
                    @click.stop
                  ></v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-select
                v-model="tipoSolicitacaoFormularioData.ordem"
                label="Ordem"
                dense
                outlined
                validate-on-blur
                hide-details
                :items="ordensPermitidas"
                :rules="[validators.select]"
              />
            </v-col>
          </v-row>

          <v-row class="justify-center ma-5">
            <v-btn
              color="primary"
              class="me-3 mb-1 mt-5"
              type="submit"
            >
              <v-progress-circular
                v-if="loading"
                class="mx-6"
                indeterminate
                color="secundary"
              />
              <span v-else>Salvar alterações</span>
            </v-btn>

            <v-btn
              color="secondary"
              class="mb-1 mt-5"
              outlined
              type="reset"
              @click="$emit('update:open-edit-formulario', false)"
            >
              Cancelar
            </v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { nameValidator, required, select } from '@core/utils/validation'
import { mdiClose, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { ref, watch } from '@vue/composition-api'
import router from '@/router'
import TipoSolicitacaoService from '@/services/modules/TipoSolicitacaoService'

export default {
  props: {
    formularioAssociado: {
      type: Object,
      default: null,
    },
    openEditFormulario: {
      type: Boolean,
      required: true,
    },
    ordensPermitidas: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const formRef = ref(null)
    const loading = ref(false)

    const tipoSolicitacaoFormularioData = ref(JSON.parse(JSON.stringify(props.formularioAssociado)))

    const toggleCheckbox = checkbox => {
      tipoSolicitacaoFormularioData.value[checkbox[0]] = !tipoSolicitacaoFormularioData.value[checkbox[0]]
      tipoSolicitacaoFormularioData.value[checkbox[1]] = !tipoSolicitacaoFormularioData.value[checkbox[1]]
    }

    const toggleCheckbox1 = checkbox => {
      if (tipoSolicitacaoFormularioData.value[checkbox[1]]) {
        tipoSolicitacaoFormularioData.value[checkbox[0]] = !tipoSolicitacaoFormularioData.value[checkbox[0]]
      }
    }

    const visivelRequired = () => {
      if (tipoSolicitacaoFormularioData.value.visivelSolicitante || tipoSolicitacaoFormularioData.value.visivelAgente) {
        return true
      }
      return ''
    }

    async function handleUpdate() {
      if (tipoSolicitacaoFormularioData.value.visivelSolicitante || tipoSolicitacaoFormularioData.value.visivelAgente) {
        try {
          loading.value = true
          const data = {
            visivelSolicitante: tipoSolicitacaoFormularioData.value.visivelSolicitante,
            editavelSolicitante: tipoSolicitacaoFormularioData.value.editavelSolicitante,
            visivelAgente: tipoSolicitacaoFormularioData.value.visivelAgente,
            editavelAgente: tipoSolicitacaoFormularioData.value.editavelAgente,
            ordem: tipoSolicitacaoFormularioData.value.ordem,
          }
          await TipoSolicitacaoService.atualizarTipoSolicitacaoFormulario(router.currentRoute.params.id, props.formularioAssociado.formularioId, data)
          emit('update:open-edit-formulario', false)
          emit('refetch-data')
        } finally {
          loading.value = false
        }
      } else {
        loading.value = false
      }
    }

    watch(
      () => tipoSolicitacaoFormularioData.value.visivelSolicitante,
      () => {
        tipoSolicitacaoFormularioData.value.editavelSolicitante = tipoSolicitacaoFormularioData.value.visivelSolicitante
      },
      {
        immediate: true,
      },
    )
    watch(
      () => tipoSolicitacaoFormularioData.value.visivelAgente,
      () => {
        tipoSolicitacaoFormularioData.value.editavelAgente = tipoSolicitacaoFormularioData.value.visivelAgente
      },
      {
        immediate: true,
      },
    )

    watch(
      () => props.openEditFormulario,
      () => {
        if (props.openEditFormulario) { tipoSolicitacaoFormularioData.value = props.formularioAssociado }
      },
      {
        immediate: true,
      },
    )

    return {
      tipoSolicitacaoFormularioData,
      formRef,
      loading,
      toggleCheckbox,
      toggleCheckbox1,
      visivelRequired,
      handleUpdate,
      validators: {
        required,
        select,
        nameValidator,
      },
      icons: {
        mdiClose,
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
    }
  },
}
</script>
